<template>
  <div id="pendubody">
    <vignette :icon="'fa-dice'" :color="'#009445'" v-if="!isMobile"></vignette>

    <div id="penduexplanation" style="text-align: center">
      <h2>Jeu du pendu</h2>
      <h3>Trouve le mot anglais et sa traduction !</h3>

      <div class="flexwrap centercenter paddingRound">
        <div class="flexwrap centercenter smallRoundAngles smallMargin paddingRound textShadow blue"
             style="color: var(--lightColor); font-weight: bold">Anglais</div>
        <div class="flexwrap centercenter smallRoundAngles smallMargin paddingRound textShadow red"
             style="color: var(--lightColor); font-weight: bold">Français</div></div>
    </div>
    <!--
    <standard-button id="pendu--end" class="flexwrap centercenter" :color-class="'red'" @click="quitGame(0)">
      <div>Terminer</div>
    </standard-button>
    -->
      <div id="penducontent" :class="!isMobile?'navTheme':''">

      <div style="height: 100%">

        <loading-logo v-if="!sessionNb||!modeSelected"> </loading-logo>
        <transition name="fade" mode="out-in" v-else appear>
          <pendu-session
                         :game-mode="mode"
                         :words-list="shuffleArray(wordsList).slice(0,10)"
                         @restart="restart()"
                         @quit="quitGame"
                         :key="sessionNb">
          </pendu-session>
        </transition>
      </div>

      </div>


  </div>
</template>

<script>
import {mapGetters, mapActions} from "vuex";
import {API_URL} from "@/App";
import {lock} from "@/main";
import axios from "axios";

export default {
name: "pendu",
  components: {
    LoadingLogo: () => import(/* webpackPrefetch: true */ '@/components/loadingLogo.vue'),
    Vignette: () => import(/* webpackPrefetch: true */ '@/components/vignette.vue'),
    //StandardButton,
    penduSession: () => import(/* webpackPrefetch: true */ '@/components/penduSession.vue'),
  },

  props: {
    wordsList: Array,
    wordsLoaded: Boolean
  },

  created() {
  if(this.wordsLoaded) {
    this.selectMode('survival')
  }

  },

  beforeDestroy() {
    this.set_gameOn(false);
    this.set_carousselNavTo(1)
    this.set_appStep(this.states.MENU);

    window.setTimeout( () =>{this.set_carousselNavTransition(true)
    }, 50);
    this.set_gameWordsListLoaded(false);
  },

  computed: {
    ...mapGetters('global', [
        'isMobile', 'profile',
      'states'
    ]),
    ...mapGetters('show', [
      'currentEpisodeData',
        'currentSeason'
    ]),
    ...mapGetters('game', [
      'gameOrigin'
    ]),
  },

  watch: {
    'wordsLoaded': function() {
      if(this.wordsLoaded) {
        this.selectMode('survival')
      }
    }
  },

  methods: {
    ...mapActions('global', [
      'set_appStep',
      'set_carousselNavTo',
      'set_carousselNavTransition',
      'set_dataReload',
    ]),
    ...mapActions('game', [
      'set_gameOn',
        'set_gameWordsListLoaded'
    ]),
    selectMode(modeName) {
      if(!this.$isDebug){
        gtag('event', 'PenduStarted', {
          'event_category': 'Game',
          'event_label': this.gameOrigin + '_' + modeName
        })

        fbq('track', 'Pendu Started');
      }
      else {
        console.log('debug mode')
      }

      this.mode = modeName;
      this.modeSelected = true;
      if(modeName === 'tenWords') {
        this.shuffleArray(this.wordsList)
      }
    },
    shuffleArray: function(tab) {
      tab.forEach((element, index, array) => {
        var j = Math.floor(Math.random() * (index + 1));
        var temp = array[index];
        array[index] = array[j];
        array[j] = temp;
      })
      return tab;
    },

    restart() {
      this.sessionNb++;
      this.shuffleArray(this.wordsList)
    },

    quitGame(currentWordNb) {
      if (this.currentEpisodeData.user_episode.play_score == null || currentWordNb > this.currentEpisodeData.user_episode.play_score) {
        //this.profile.datas.points += 5 * currentWordNb
        if (this.currentEpisodeData.user_episode.play_score != null) {
          //this.profile.datas.points -= 5 * this.currentEpisodeData.user_episode.play_score
        }

        this.currentEpisodeData.user_episode.play_check = true
        this.currentEpisodeData.user_episode.play_score = currentWordNb

        /*this.profile.datas.points += this.currentWordNb*5*/
        let payload = {
          "play_check": this.currentEpisodeData.user_episode.play_check,
          "play_score": this.currentEpisodeData.user_episode.play_score,
        }
        const url = `${API_URL}/api/auth0userepisode/` + this.currentEpisodeData.id + '/'

        this.$webAuth.checkSession({}, (error, authResult) => {
          if(!error) {
            axios.patch(url, payload, {headers: {Authorization: `Bearer ${authResult.accessToken}`}})
                .then((response) => {
                  // Données à changer :
                  // Episode : play_check, play_score
                  // Score global
                  // Score saison
                  this.set_dataReload()
                })
          }
          else {
            console.log(error)
          }
        })
      }

      this.set_gameOn(false);
      this.set_appStep(this.states.MENU)
    }

  },

  data() {
    return {
      modeSelected: false,
      mode: 'survival',
      sessionNb: 1
    }
  }
}
</script>

<style scoped>

  #pendubody{
    display: grid;
    grid-template-columns: 2fr 5fr;
    grid-template-rows: auto 1fr auto;
    padding: 1vw;
    grid-gap: 1vw;
    /*height: calc(100% - 2vw);*/
    flex-grow: 1;
  }

  #penduexplanation{
    grid-column: 1/2;
    grid-row: 2/3;
    border-radius: 1vw;
    height: min-content;
    padding: 0.5vw;
  }

  #pendu--end{
    grid-column: 1/2;
    grid-row: 3/4;
  }

  #penducontent{
    grid-column: 2/3;
    grid-row: 1/4;
    position: relative;
    border-radius: 1vw;
  }

  .title {
    text-align: center;
  }

  .menu {
    width: 30%;
    justify-self: center;
  }

  .modeOption {
    margin: 2vw;
    padding-bottom: 0px;
    padding-right: 0px;
    border: 1px solid whitesmoke;
  }

  .modeOption:hover {
    box-shadow: 0.5vw 0.5vw 1px 1px;
  }

  .modeDescription {
    display: flex;
    margin-bottom: 0px;
    margin-right: 0px;
    border-top-right-radius: 0px;
    font-style: italic;
  }

  @media screen and (max-device-width: 767px) {

    #pendubody{
      display: grid;
      grid-template-columns: 1fr;
      grid-template-rows: auto 1fr;
      padding: 3vw;
      height: calc(100% - 6vw);
      min-height: 75vh;
    }
    #penduexplanation{
      grid-column: 1/2;
      grid-row: 1/2;
      border-radius: 0;
      height: min-content;
      padding: 0.5vw;
      border-bottom: 0.1vw solid #88888888;
      /*border-radius: 1vw;*/
    }

    #penducontent{
      grid-column: 1/2;
      grid-row: 2/3;
      border-radius: 0;
    }

    .modeOption {
      margin: 5vw;
    }
  }

</style>